export default __webpack_public_path__ + "static/media/whyPage-whyTab.e5e39cc0.svg";